export const environment = {
  production: true,
  apiKey: "5f3cd49bf3bc85f2558e6421",
  apiURL: "https://shark-app-fq7ij.ondigitalocean.app",
  //ipCheckerURL: 'https://api.ipify.org/?format=json',
  ipCheckerURL: 'https://ipapi.co/json',
};
